import { GET_ALL_DISCOUNTS, UPDATE_DISCOUNT, CREATE_DISCOUNT, UPDATE_DISCOUNT_PENDING } from '../../constants';

export default {
  [GET_ALL_DISCOUNTS](state, data) {
    state.discounts = data;
  },
  [UPDATE_DISCOUNT](state, data) {
    state.discounts = state.discounts.map((el) => {
      if (el._id === data._id) {
        Object.assign(el, data);
      }
      return {
        ...el
      };
    });
  },
  [CREATE_DISCOUNT](state, data) {
    state.discounts.push(data);
  },
  [UPDATE_DISCOUNT_PENDING](state, data) {
    state.pendingDiscount = data;
  }
};
